import { render } from "./MobilePlanetaryPositions.vue?vue&type=template&id=435e3e15&scoped=true"
import script from "./MobilePlanetaryPositions.vue?vue&type=script&lang=js"
export * from "./MobilePlanetaryPositions.vue?vue&type=script&lang=js"

import "./MobilePlanetaryPositions.vue?vue&type=style&index=0&id=435e3e15&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435e3e15"]])

export default __exports__